import { SET_USERS, SET_USER_ONLINE, SET_USER_OFFLINE } from '../actions/types';

// holds all users belonging to the current business
export default function usersReducer(state = [], action) {
	switch (action.type) {
		case SET_USERS: {
			if (Array.isArray(action.payload)) {
				// sort by name
				return action.payload.sort((a, b) => {
					const nameA = (a.name || '').toString();
					const nameB = (b.name || '').toString();
					return nameA.localeCompare(nameB);
				});
			}
			return action.payload || state;
		}

		case SET_USER_ONLINE: {
			const { _user } = action.payload;

			const users = state.map((u) => {
				if (u._id === _user) {
					return { ...u, isOnline: true };
				}
				return u;
			});

			return users;
		}

		case SET_USER_OFFLINE: {
			const { _user } = action.payload;

			const users = state.map((u) => {
				if (u._id === _user) {
					return {
						...u,
						isOnline: false,
						lastOnlineAt: new Date().toISOString(),
					};
				}
				return u;
			});

			return users;
		}

		default:
			return state;
	}
}
